export const shortenEmail = (email: string, lengthChecker: number) => {
  const [name, domain] = email.split('@');
  const limit = lengthChecker > 25 ? 30 : 60;

  const toShorten = name.length > limit;
  const local = toShorten ? name.slice(0, limit) : name;
  if (!domain) {
    return `${local}${toShorten ? '...' : ''}`;
  }
  return `${local}${toShorten ? '...' : ''}@${domain}`;
};

export const shortenFile = (fileName: string, limit = 40) => {
  const split = fileName.split('.');
  if (split.length === 1) return { name: fileName, isShortened: false };
  const [name, extension] = split;
  const toShorten = name.length > limit;
  const local = toShorten ? name.slice(0, limit) : name;
  return {
    name: `${local}${toShorten ? '...' : ''}.${extension}`,
    isShortened: toShorten,
  };
};
